module.exports = __webpack_public_path__ + "sr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sr.svg
// module id = 815
// module chunks = 0